/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Restore_PurchasesInputs */

const en_plan_restore_purchases = /** @type {(inputs: Plan_Restore_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restore Purchases`)
};

const es_plan_restore_purchases = /** @type {(inputs: Plan_Restore_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restaurar compras`)
};

/**
* | output |
* | --- |
* | "Restore Purchases" |
*
* @param {Plan_Restore_PurchasesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_restore_purchases = /** @type {((inputs?: Plan_Restore_PurchasesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Restore_PurchasesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_restore_purchases(inputs)
	return en_plan_restore_purchases(inputs)
});